import o from "./ghl-ui.es1579.js";
import f from "./ghl-ui.es1661.js";
import u from "./ghl-ui.es1466.js";
function O(e) {
  u(1, arguments);
  var t = o(e), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var a = f(r);
  return a;
}
export {
  O as default
};
